import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Divider } from '@material-ui/core';
import Tile from '../../../shared/components/Tile';
import ChatAvatar from '../../../shared/components/ChatAvatar';

const PendencyLinks = (props) => {
  const { t, involved, employee } = props;

  const buildCreators = () => {
    return (
      <Tile
        content={
          <div className="creator-tile">
            <div className="creator-avatar">
              <ChatAvatar
                size="36"
                round="50%"
                name={employee.name}
                urlPhoto={employee.fileUrl}
              />
            </div>
            <div>
              <div className="font-weight-bold">{employee.name}</div>
            </div>
          </div>
        }
      />
    );
  };

  const buildInvolved = () => {
    return (
      <>
        {involved.map((item) => (
          <Fragment key={item.id}>
            <Tile
              content={
                <div className="involved-tile">
                  <div className="involved-avatar">
                    <ChatAvatar
                      size="36"
                      round="50%"
                      urlPhoto={item.photoUrl}
                      name={item.description}
                    />
                  </div>
                  <div>{item.description}</div>
                </div>
              }
            />
            <Divider orientation="horizontal" />
          </Fragment>
        ))}
      </>
    );
  };

  return (
    <div className="pendency-links">
      <div className="pendency-creator">
        <div className="title">{t('general.creator-name')}</div>
        {buildCreators()}
        <Divider orientation="horizontal" />
      </div>
      <div className="pendency-involved">
        <div className="title">{t('general.involved')}</div>
        <div className="pendency-involved-content">{buildInvolved()}</div>
      </div>
    </div>
  );
};

PendencyLinks.propTypes = {
  t: PropTypes.func.isRequired,
  employee: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    fileUrl: PropTypes.string,
  }).isRequired,
  involved: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      photoUrl: PropTypes.string,
      description: PropTypes.string,
    })
  ).isRequired,
};

export default withTranslation('common')(memo(PendencyLinks));
